import { ENV, trpc } from "@src/utils"
import { Pressable, View } from "react-native"
import { MenuActions, Text, Image } from "@src/components"
import { Href, Link } from "expo-router"
import { ar } from "@src/i18n"

type AnnouncementCardProps = {
  announcement: {
    id: number
    title: string
    description?: string | null
    entity: "product" | "section" | "collection"
    entityId: number
    status: "active" | "inactive"
  }
  href: Href
  image: { key: string; thumbhash?: string | null } | undefined
  isArchived: boolean
  onRefresh: () => void
  onEdit: () => void
}

export function AnnouncementCard({ announcement, href, image, isArchived, onRefresh, onEdit }: AnnouncementCardProps) {
  const toggleStatus = trpc.menu.toggleAnnouncementStatus.useMutation()
  const deleteAnnouncement = trpc.menu.deleteAnnouncement.useMutation()

  const handleToggleStatus = (newStatus: "active" | "inactive") => {
    toggleStatus.mutate({ id: announcement.id, status: newStatus }, { onSuccess: onRefresh })
  }

  const handleDelete = async () => {
    try {
      await deleteAnnouncement.mutateAsync({ id: announcement.id })
      onRefresh()
      return undefined
    } catch (error) {
      return error instanceof Error ? error.message : "Failed to delete"
    }
  }

  const isPending = toggleStatus.isPending || deleteAnnouncement.isPending

  return (
    <View className="mb-2 py-2 px-2 relative">
      <Link href={href} asChild>
        <Pressable className={`${isArchived ? "opacity-50" : ""}`}>
          <Image
            source={`${ENV.R2_URL}/${image?.key}`}
            style={{ height: 40 * 4, aspectRatio: 2.25 }}
            contentFit="contain"
            loading="lazy"
            recyclingKey={announcement.id.toString()}
            cachePolicy="memory"
            transition={250}
          />
          <Text className="text-lg font-bold absolute top-2 start-2 bg-white px-2 py-1">{announcement.title}</Text>
          {isArchived && (
            <View className="absolute top-2 start-2 mt-10 bg-yellow-500 px-2 py-0.5 rounded">
              <Text className="text-xs text-white font-semibold">{ar.inactive}</Text>
            </View>
          )}
        </Pressable>
      </Link>
      <MenuActions itemName={announcement.title} status={announcement.status} onToggleStatus={handleToggleStatus} onDelete={handleDelete} onEdit={onEdit} isPending={isPending} />
    </View>
  )
}
